import React, { useState } from 'react';
import {
    Box,
    TextField,
    Typography,
    Button,
    CircularProgress
} from '@mui/material';
import { useHistory } from 'react-router-dom';

export const CheckCustomer = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        phone: '',
        panNumber: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        // Handle form submission here.
        setLoading(false);
    };

    const handleClear = () => {
        setFormData({
            username: '',
            email: '',
            phone: '',
            panNumber: ''
        });
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100vh"
            position="relative"
        >
            <Box
                position="absolute"
                top="20px"
                width="100%"
                maxWidth="500px"
                padding="20px"
                backgroundColor="#fff"
                borderRadius="8px"
                boxShadow="0 4px 8px rgba(0, 0, 0, 0.2)"
                border="1px solid rgba(0, 0, 0, 0.1)"
                paddingBottom="20px"
            >
                <Typography
                    variant="h5"
                    gutterBottom
                    align="center"
                    sx={{
                        fontWeight: 'bold',
                        textShadow: '1px 1px 2px rgba(0, 0, 0, 0.2)',
                        color: '#333'
                    }}
                >
                    Check Customer
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="User Name"
                        name="username"
                        value={formData.username}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        label="Email ID"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        label="Phone Number"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        label="PAN Number"
                        name="panNumber"
                        value={formData.panNumber}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        mt={2}
                    >
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            width="100%"
                            mb={2}
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={handleClear}
                                style={{ flexGrow: 1, marginRight: 8 }}
                            >
                                Clear
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                style={{ flexGrow: 1 }}
                            >
                                {loading ? (
                                    <CircularProgress size={24} />
                                ) : (
                                    'Submit'
                                )}
                            </Button>
                        </Box>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            mb={2}
                            align="center"
                            sx={{
                                fontWeight: 'bold',
                                textShadow: '1px 1px 2px rgba(0, 0, 0, 0.2)',
                                color: '#333'
                            }}
                        >
                            If you are new, please register, or log in if you
                            already have an account.
                        </Typography>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            width="100%"
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    history.push(
                                        '/LoanDistributor/CustomerRegistration'
                                    );
                                }}
                                style={{ flexGrow: 1, marginRight: 8 }}
                            >
                                Register
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    history.push(
                                        '/LoanDistributor/LoginCustomer'
                                    );
                                }}
                                style={{ flexGrow: 1 }}
                            >
                                Login
                            </Button>
                        </Box>
                    </Box>
                </form>
            </Box>
        </Box>
    );
};
